"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardTache = /** @class */function () {
    function DashboardTache(data) {
        if (data != null) {
            this.libelleAction = data.libelleAction;
            this.taskId = data.taskId;
        }
    }
    return DashboardTache;
}();
exports.DashboardTache = DashboardTache;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/Models/DashboardTache.ts
// module id = 533
// module chunks = 0